import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=6104cba0&scoped=true&lang=pug"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"
import style0 from "./Threads.vue?vue&type=style&index=0&id=6104cba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6104cba0",
  null
  
)

export default component.exports